<template>
    <div class="mapModal" :style="{display:modalDisplay}">
        <div class="mapModal_main">
            <div class="mapModal_main_title">
                <input id="searchInput" type="text">
                <img src="../../assets/images/close_circle_fill.png" alt="" @click="closeOpenModal('none')">
            </div>
            <div id="map">

            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted,onBeforeUnmount, ref, getCurrentInstance, watch} from 'vue';
    import  mapFunction from '../../assets/js/map.js';
    // import remoteLoad from '../../assets/js/remoteload.js';

    export default {
        name: "Map",
        setup() {
            const {proxy} = getCurrentInstance();
            //地图加载
            const loadMap = async () => {
                // 更改地图加载方式为maoLoader.js加载，原加载方式会重复加载js并导致地图渲染异常
                // var url = 'https://webapi.amap.com/maps?v=1.4.15&key=89d266d11730bc0017e39be726bc4985&plugin=AMap.Autocomplete,AMap.PlaceSearch';
                // // var url = 'https://webapi.amap.com/maps?v=2.0&key=89d266d11730bc0017e39be726bc4985&plugin=AMap.MapboxVectorTileLayer';
                // await remoteLoad(url);
                // await remoteLoad("//webapi.amap.com/ui/1.1/main.js?v=1.1.1");

                mapFunction.mapInit({proxy});
                searchPlace()
            }
            const searchPlace = () => {
                var autoOptions = {
                    input: "searchInput",
                    city: '010' //城市，默认全国
                };
                mapFunction.autoSearch(autoOptions)
            }
            const modalDisplay = ref("none");
            const closeOpenModal = (param) => {
                modalDisplay.value = param
            }
            onMounted(() => {
                loadMap();
            })
            onBeforeUnmount(() => {
                mapFunction.mapDestroy();
            })
            return {
                closeOpenModal,
                modalDisplay
            }
        }
    }
</script>

<style lang="less">
    .amap-sug-result{
        display: none;
    }
    .mapModal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 100;
        .mapModal_main {
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 1000px;
            padding: 20px;
            .mapModal_main_title {
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            input {
                height: 32px;
                width: 300px;
                background: #FFFFFF;
                border: 1px solid #CFD3E4;
                border-radius: 4px;
                padding-left: 8px;
            }
            img {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
            #map {
                height: 600px;
                width: 100%;
            }
        }
    }
</style>
